module.exports = __webpack_public_path__ + "img/download-icon.290eed54.svg";